import React from 'react';
import { Alert, Box, IconButton, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { KEY_DISPLAY_LENGTH, styles } from './ApiKeyUtil';

const NewApiKeyAlert = ({ apiKeyCreated, showNewKey, onToggleVisibility, onCopyKey, copyIcon }) => (
  <Alert severity="success" sx={styles.alert.base}>
    <Box sx={{ mb: 1 }}>
      <Typography variant="subtitle2">API key created successfully</Typography>
      <Typography variant="caption" color="text.secondary">
        Copy your key now. You won't be able to see it again.
      </Typography>
    </Box>
    <Box sx={styles.alert.keyContainer}>
      <Box sx={styles.alert.keyTextContainer}>
        <Typography variant="body2" sx={styles.alert.keyText}>
          {showNewKey ? apiKeyCreated.key : '•'.repeat(KEY_DISPLAY_LENGTH)}
        </Typography>
      </Box>
      <Box sx={styles.alert.buttonContainer}>
        <IconButton size="small" onClick={onToggleVisibility} sx={styles.alert.visibilityButton}>
          {showNewKey ? (
            <VisibilityOffIcon fontSize="small" />
          ) : (
            <VisibilityIcon fontSize="small" />
          )}
        </IconButton>
        <Tooltip title={copyIcon === 'copy' ? 'Copy to clipboard' : 'Copied!'} placement="top">
          <IconButton size="small" onClick={() => onCopyKey(apiKeyCreated.key)}>
            {copyIcon === 'copy' ? (
              <ContentCopyIcon fontSize="small" />
            ) : (
              <CheckCircleOutlineIcon fontSize="small" color="success" />
            )}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  </Alert>
);

export default NewApiKeyAlert;
